import { Grid } from "@material-ui/core";
import { get } from "lodash";
import React from "react";
import {
	email,
	LinearProgress,
	required,
	SelectInput,
	TextInput,
	useGetList,
} from "react-admin";
import { useForm, useFormState } from "react-final-form";
import GridSingle from "../../components/GridSingle";

const getRules = (config) => {
	switch (config.validate) {
		case "email":
			return [required(), email()];
		case "required":
			return [required()];
		default:
			return [];
	}
};

const PaymentMethodsInput = ({ source, permissions, ...props }) => {
	const { data: paymentMethods, loading } = useGetList(
		"payment-methods",
		{
			page: 1,
			perPage: 10,
		},
		{
			field: "name",
			order: "ASC",
		}
	);
	const formState = useFormState();
	const form = useForm();
	const paymentMethodId = get(formState.values, `${source}_id`, null);
	const paymentMethodConfig = JSON.parse(
		get(paymentMethods, `${paymentMethodId}.config`, "{}")
	);

	if (loading) {
		return <LinearProgress />;
	}

	return (
		<Grid container>
			<GridSingle md={12}>
				<SelectInput
					label="ra.profile.fields.profile.payment_method_id"
					source={`${source}_id`}
					choices={Object.keys(paymentMethods).map((id) => paymentMethods[id])}
					onChange={() => {
						form.batch(() => {
							form.change(`${source}_data`, undefined);
						});
					}}
					emptyValue=""
					emptyText="ra.payment_method.none"
					allowEmpty={true}
					validate={permissions && permissions("user") ? required() : () => {}}
					{...props}
				/>
			</GridSingle>
			{Object.keys(paymentMethodConfig).length > 0 && (
				<Grid container>
					{Object.keys(paymentMethodConfig).map((field) => {
						let config = get(paymentMethodConfig, field, {});
						return (
							<GridSingle key={field} md={7}>
								<TextInput
									{...config}
									{...props}
									source={`${source}_data.${field}`}
									id={`${source}_data.${field}`}
									label={`ra.profile.fields.${field}`}
									validate={getRules(config)}
									fullWidth
									className=""
								/>
							</GridSingle>
						);
					})}
				</Grid>
			)}
		</Grid>
	);
};
export default PaymentMethodsInput;
